import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

const statePaths = [
  ['authentication'],
  ['claims', 'getClaims'],
  ['claims', 'getGWClaims'],
  ['claims', 'createClaim'],
  ['claims', 'createShellClaim'],
  ['claims', 'updateClaim'],
  ['claims', 'submitClaim'],
  ['policyDetails'],
  ['services', 'uber', 'createVoucher'],
  ['services', 'enterprise', 'searchLocations'],
  ['services', 'enterprise', 'createRental'],
  ['services', 'audatarget', 'searchVendor'],
  ['services', 'audatarget', 'availability'],
  ['services', 'audatarget', 'bookAppointment'],
];

const selectLoading = (state) => {
  let i = 0;
  let loading = fromJS({ loading: false });

  do {
    const content = getStateContent(state, statePaths[i]);
    loading = fromJS({ loading: content.getIn(['loading']) }) || loading;

    i += 1;
  } while (i < statePaths.length && loading.getIn(['loading']) === false);

  return loading;
};

const getStateContent = (state, path) => {
  let i = 1;
  let content = state[path[0]];

  while (i < path.length) {
    content = content.getIn([path[i]]);
    i += 1;
  }

  return content;
};

export const loadingSelector = createSelector(selectLoading, (state) => state?.toJS());
